import { createFileRoute, Link } from "@tanstack/react-router";
import { DashboardShell, StatCard, PlaceholderCard } from "@/components/DashboardShell";
import { CUSTOMER_NAV } from "@/lib/nav";
import { Heart, Send, Unlock, BadgeCheck } from "lucide-react";

export const Route = createFileRoute("/_authenticated/customer/dashboard")({
  head: () => ({
    meta: [
      { title: "Your dashboard · Landoo" },
      { name: "description", content: "Your saved properties, enquiries and unlocks on Landoo." },
    ],
  }),
  component: () => (
    <DashboardShell title="Welcome back" role="Customer" items={CUSTOMER_NAV}>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Favourites" value={4} icon={Heart} />
        <StatCard label="Enquiries sent" value={2} icon={Send} />
        <StatCard label="Contact unlocks" value={1} icon={Unlock} />
        <StatCard label="Verification" value="Started" icon={BadgeCheck} />
      </div>
      <div className="mt-6 grid gap-3 md:grid-cols-2">
        <PlaceholderCard
          title="Personalised alerts"
          description="Get notified when new properties match your saved searches."
        >
          <Link
            to="/search"
            className="inline-flex rounded-full bg-brand px-4 py-2 text-xs font-semibold text-brown-dark shadow-soft"
          >
            Start searching
          </Link>
        </PlaceholderCard>
        <PlaceholderCard
          title="Complete verification"
          description="Verified buyers get priority responses from owners."
        >
          <Link
            to="/customer/verification"
            className="inline-flex rounded-full bg-coral px-4 py-2 text-xs font-semibold text-white shadow-soft"
          >
            Verify now
          </Link>
        </PlaceholderCard>
      </div>
    </DashboardShell>
  ),
});
